import {
  FileSearch2,
  Grid2X2,
  Network,
  PackageSearch,
  Wind,
} from 'lucide-react';
import { NavItem, QuickLinks } from '../models/nav-item.model';

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Category Insights',
    icon: <Network />,
    route: '/category-insights/dashboards',
    section: '/category-insights',
    id: 'category-insights-nav-item',
    child: [
      {
        label: 'Category Dashboards',
        route: '/category-insights/dashboards',
        section: '/category-insights',
        id: 'category-dashboard-nav-item',
      },
      {
        label: 'Category Reports',
        route: '/category-insights/reports',
        section: '/category-insights',
        id: 'category-report-nav-item',
      },
      // {
      //   label: 'Accuracy Reports',
      //   route: '/category-insights/accuracy-report',
      //   section: '/category-insights',
      //   id: 'historical-accuracy-nav-item',
      // },
    ],
  },
  {
    id: 'tradewinds-nav-item',
    label: 'Tradewinds',
    icon: <Wind />,
    route: '/tradewinds/',
    section: '/tradewinds',
    child: [
      {
        label: 'Market Size Tracker',
        route: '/tradewinds/market-size-tracker',
        section: '/tradewinds',
        id: 'base-module-nav-item',
      },
      // {
      //   label: 'Top Shops',
      //   route: '/tradewinds/top-shops',
      //   section: '/tradewinds',
      //   id: 'top-shops-nav-item',
      // },
      {
        label: 'Shopee Forecast',
        route: '/tradewinds/shopee-forecast',
        section: '/tradewinds',
        id: 'shopee-forecast-nav-item',
      },
      {
        label: 'Seller Panel',
        route: '/tradewinds/seller-panel',
        section: '/tradewinds',
        id: 'seller-panel-nav-item',
      },
    ],
  },
  {
    label: 'OSCX',
    icon: <PackageSearch />,
    route: '/oscx',
    id: 'oscx-nav-item',
  },
  {
    id: 'digital-shelf-nav-item',
    label: 'Digital Shelf',
    icon: <Grid2X2 />,
    route: '/digital-shelf',
    section: '/digital-shelf',
    child: [
      {
        label: 'Global Score Card',
        route: '/digital-shelf/global-score-card',
        section: '/digital-shelf',
        id: 'global-score-card-nav-item',
      },
      {
        label: 'Product Health',
        route: '/digital-shelf/product-health',
        section: '/digital-shelf',
        id: 'product-health-nav-item',
      },
      {
        label: 'Share of Search',
        route: '/digital-shelf/share-of-search',
        section: '/digital-shelf',
        id: 'share-of-search-nav-item',
      },
      {
        label: 'Banner Presence',
        route: '/digital-shelf/banner-presence',
        section: '/digital-shelf',
        id: 'banner-presence-nav-item',
      },
      {
        label: 'Price Tracking',
        route: '/digital-shelf/price-tracking',
        section: '/digital-shelf',
        id: 'price-tracking-nav-item',
      },
    ],
  },
  // {
  //   label: 'Market Snapshot',
  //   icon: <LineChart />,
  //   route: '/market-snapshot',
  //   id: 'market-snapshot',
  // },
  {
    label: 'Custom Research',
    icon: <FileSearch2 />,
    route: '/custom-research',
    id: 'research-nav-item',
  },
  // {
  //   label: "System",
  //   icon: <BiCog />,
  //   route: "/system",
  //   id: "system-nav-item",
  // },
];

export const QUICK_LINKS: QuickLinks[] = [
  {
    id: 'hub-quick-link-category-insights',
    label: 'Category Insights',
    description:
      'Explore subscribed dashboards and monitor the categories that matter most.',
    route: '/category-insights/dashboards',
    icon: <Network className="size-5" />,
    cta: 'Go to dashboards',
  },
  {
    id: 'hub-quick-link-tradewinds',
    label: 'Tradewinds',
    description:
      'Jump into market sizing, growth tracking, and strategic planning views.',
    route: '/tradewinds/market-size-tracker',
    icon: <Wind className="size-5" />,
    cta: 'Go to Tradewinds',
  },
  // {
  //   id: 'hub-quick-link-market-snapshot',
  //   label: 'Market Snapshot',
  //   description:
  //     'One-stop destination for comprehensive analysis and trends in global e-commerce markets',
  //   route: '/market-snapshot',
  //   icon: <LineChart className="size-5" />,
  //   cta: 'Go to Market Snapshot',
  // },
  {
    label: 'OSCX™',
    icon: <PackageSearch />,
    route: '/oscx',
    id: 'hub-quick-link-oscx',
    description:
      'Proprietary benchmark of e-commerce seller sentiment across Southeast Asia and other key Shopee markets',
    cta: 'Go to OSCX',
  },
  {
    label: 'Digital Shelf',
    icon: <Grid2X2 />,
    route: '/digital-shelf',
    id: 'hub-quick-link-digital-shelf',
    description:
      'Turning online visibility into e-commerce growth by unlocking deeper insights for the next action',
    cta: 'Go to Digital Shelf',
  },
  {
    label: 'Custom Research',
    icon: <FileSearch2 />,
    route: '/custom-research',
    id: 'hub-quick-link-custom-research',
    description:
      'Looking for a specific insight? Tell us what you’re exploring, and we’ll help you find the answers you need.',
    cta: 'Request Custom Research',
  },
];
